import { thumb } from "../lib/catalog";
import { ZoomImage } from "./Lightbox";

export function CatalogThumb({
  url,
  small,
  alt,
  beside,
}: {
  url: string | null | undefined;
  small?: boolean;
  alt?: string;
  /** The scan photo, shown next to the catalog picture when zoomed. */
  beside?: string;
}) {
  const cls = `catalog-thumb${small ? " small" : ""}`;
  if (!url) return <div className={`${cls} placeholder`}>{small ? "" : "no picture"}</div>;
  return <ZoomImage className={cls} src={thumb(url)} full={url} beside={beside} alt={alt} loading="lazy" />;
}
